import { Collection, TextInput, Image, MultilineInput, NumberInput } from "@tblabs/truffle";
import { CollectionItemPrinter } from "../../Utils/CollectionItemPrinter";
import { GalleryItem } from "../../../Models/Description/Gallery/GalleryItem";
import { Box } from "../../Utils/Box";
import { FormRow, FormPrinter } from "../../../Pages/Product/InputsPrinter";


export class GalleryItemEditor extends CollectionItemPrinter<GalleryItem>
{
    constructor(image: GalleryItem, images: Collection<GalleryItem>)
    {
        super(image, images, [new Image(image.ThumbnailUrl).MaxHeight(180).ObjectFit("cover")]);

        this.AddContent(
            new FormPrinter([
                new FormRow("Znormalizowany obraz", new TextInput(image.NormalizedUrl).Placeholder("Znormalizowany obraz").WidthPercent(100)),
                new FormRow("Miniatura", new TextInput(image.ThumbnailUrl).Placeholder("Miniatura").WidthPercent(100)),
                new FormRow("Mikro", new TextInput(image.MiniUrl).Placeholder("Mikro").WidthPercent(100)),
                new FormRow("Offset (x/y)", new Box(
                    new NumberInput(image.XOffset).Step(10).WidthPercent(50), 
                    new NumberInput(image.YOffset).Step(10).WidthPercent(49).MarginLeft(1, "%"),
                )),
                new FormRow("Opis", new MultilineInput(image.Description).Rows(2).Placeholder("Opis").WidthPercent(100)),
            ]),
        )
    }
}
